<div  class="container">
  @if (active === 'left') {
    <div class="left" [animate.enter]="direction === 'left' ? 'frame-enter-left' : 'frame-enter-right'" [animate.leave]="direction === 'left' ? 'frame-leave-right' : 'frame-leave-left'">
      <ng-container *ngTemplateOutlet="leftElement"></ng-container>
    </div>
  }
  @if (active === 'right') {
    <div class="right" [animate.enter]="direction === 'left' ? 'frame-enter-left' : 'frame-enter-right'" [animate.leave]="direction === 'left' ? 'frame-leave-right' : 'frame-leave-left'">
      <ng-container *ngTemplateOutlet="rightElement"></ng-container>
    </div>
  }
</div>
<ng-template #cart>
  <div class="order">
    <h1 class="welcome">Chcę rameczkę!</h1>
    <div class="frames" [formGroup]="model">
      <div class="space"></div>
      <div class="frame">
        <h1 class="white" [ngClass]="{ active: whiteFocused$ | async }">
          <span>Białą</span>
        </h1>
        <div class="number">
          <app-change-number
            formControlName="white"
            (focused)="whiteFocused$.next(true)"
            (blurred)="whiteFocused$.next(false)"
            [maxNumber]="1000"
            [step]="5"
            [minNumber]="0"
          ></app-change-number>
        </div>
      </div>

      <div class="space"></div>
      <div class="space"></div>
      <div class="frame">
        <h1 class="black" [ngClass]="{ active: blackFocused$ | async }">
          <span>Czarną</span>
        </h1>
        <div class="number">
          <app-change-number
            formControlName="black"
            (focused)="blackFocused$.next(true)"
            (blurred)="blackFocused$.next(false)"
            [maxNumber]="1000"
            [step]="5"
            [minNumber]="0"
          ></app-change-number>
        </div>
      </div>
      <div class="space"></div>
    </div>
    <h1 class="total">Suma: {{ total$ | async | currency: 'PLN' }}</h1>
    <div class="delivery">
      @if ((total$ | async) < 1500) {
        <h2>Koszt dostawy 20 zł</h2>
        <p>Darmowa dostawa od 1 500 zł</p>
      } @else {
        <p class="free">Darmowa dostawa</p>
      }
      <ng-template #freeDelivery>
        <p class="free">Darmowa dostawa</p></ng-template
      >
    </div>
    <div
      class="placeOrder"
      [ngClass]="{ disabled: (total$ | async) === 0 }"
      (click)="goToDetails()"
    >
      <span>Dalej</span>
    </div>
  </div>
</ng-template>
<ng-template #buyer>
  <div class="buyer" [formGroup]="model">
    <div class="buyerHeader">
      <div>
        <lib-button icon-only (click)="goToCart()">
          <mat-icon> arrow_back </mat-icon>
        </lib-button>
      </div>
      <h1 class="invoiceHeader">Dane do faktury</h1>
      <div></div>
    </div>

    <mat-form-field libZalamoField>
      <mat-label>Nazwa firmy</mat-label>
      <input type="text" matInput formControlName="companyName" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <mat-form-field libZalamoField>
      <mat-label>NIP</mat-label>
      <input type="text" matInput formControlName="companyVatId" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
    <div class="companyAddress">
      <mat-form-field libZalamoField>
        <mat-label>Ulica</mat-label>
        <input type="text" matInput formControlName="companyStreet" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
      <mat-form-field libZalamoField>
        <mat-label>Numer budynku</mat-label>
        <input type="text" matInput formControlName="companyBuildingNumber" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
      <span>/</span>
      <mat-form-field libZalamoField>
        <mat-label>Numer mieszkania</mat-label>
        <input type="text" matInput formControlName="companyFlatNumber" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
    </div>
    <div class="invoice_address">
      <mat-form-field libZalamoField>
        <mat-label>Miasto</mat-label>
        <input type="text" matInput formControlName="companyCity" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
      <mat-form-field libZalamoField>
        <mat-label>Kod pocztowy</mat-label>
        <input type="text" matInput formControlName="companyZipCode" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
    </div>
    <h1>Dane odbiorcy</h1>
    <div class="client_name">
      <mat-form-field libZalamoField>
        <mat-label>Imię</mat-label>
        <input type="text" matInput formControlName="clientFirstName" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
      <mat-form-field libZalamoField>
        <mat-label>Nazwisko</mat-label>
        <input type="text" matInput formControlName="clientLastName" />
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
    </div>

    <mat-form-field libZalamoField>
      <mat-label>numer telefonu</mat-label>
      <input type="tel" matInput formControlName="clientPhone" />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>

    @if (model.get('deliveryType').value === 'courier') {
      <lib-checkbox formControlName="deliveryAddressSameAsCompany"
        >Dostawa na firmowy adres
      </lib-checkbox>
    }
    @if (model.get('deliveryType').value === 'locker') {
      <div class="locker">
        @if (model.get('lockerId').value) {
          <div class="pickedLocker">
            <div>Paczkomat: {{ model.get('lockerId').value }}</div>
            <div>
              @for (part of model.value.lockerAddress; track part) {
                <div>
                  {{ part }}
                </div>
              }
            </div>
            <div>
              <lib-button>Zmień</lib-button>
            </div>
          </div>
        } @else {
          <span class="noLocker"
            ><lib-button (click)="pickLocker()">
              Wybierz paczkomat
            </lib-button></span
          >
        }
        <ng-template #noLocker>
          <span class="noLocker"
            ><lib-button (click)="pickLocker()">
              Wybierz paczkomat
            </lib-button></span
          >
        </ng-template>
      </div>
    }
    @if (
      model.value.deliveryType === 'courier' &&
      !model.value.deliveryAddressSameAsCompany
    ) {
      <div class="courierDeliveryDetails" [formGroup]="courierDeliveryModel">
        <div class="companyAddress">
          <mat-form-field libZalamoField>
            <mat-label>Ulica</mat-label>
            <input type="text" matInput formControlName="deliveryStreet" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
          <mat-form-field libZalamoField>
            <mat-label>Numer budynku</mat-label>
            <input
              type="text"
              matInput
              formControlName="deliveryBuildingNumber" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
          <span>/</span>
          <mat-form-field libZalamoField>
            <mat-label>Numer mieszkania</mat-label>
            <input type="text" matInput formControlName="deliveryFlatNumber" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
        </div>
        <div class="invoice_address">
          <mat-form-field libZalamoField>
            <mat-label>Miasto</mat-label>
            <input type="text" matInput formControlName="deliveryCity" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
          <mat-form-field libZalamoField>
            <mat-label>Kod pocztowy</mat-label>
            <input type="text" matInput formControlName="deliveryZipCode" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
        </div>
      </div>
    }
    <div
      class="placeOrder"
      (click)="goToFinalize()"
      [ngClass]="{ disabled: !detailsValid }"
    >
      <span>Dalej</span>
    </div>
  </div>
</ng-template>
<ng-template #finalize>
  <div class="finalize" [formGroup]="acceptanceModel">
    <div>
      <lib-button icon-only (click)="goToDetailsFromBasket()">
        <mat-icon> arrow_back </mat-icon>
      </lib-button>
    </div>
    <div class="spacer"></div>
    <lib-checkbox formControlName="deliveryDate"
      >Akceptuję fakt, że wysyłka zostanie zrealizowana między 20 a 25
      października
    </lib-checkbox>
    <div class="tos">
      <lib-checkbox formControlName="tos">Akceptuję</lib-checkbox>
      <lib-button bare (click)="showTos()">Regulamin</lib-button>
    </div>
    <h1>Do zapłaty {{ totalWithDelivery$ | async | currency: 'PLN' }}</h1>
    <div
      class="placeOrder"
      (click)="placeOrder()"
      [ngClass]="{ disabled: acceptanceModel.invalid }"
    >
      @if (!(orderInProgress$ | async)) {
        <span>Zamów i opłać</span>
      } @else {
        Zamawiam
        <mat-spinner [diameter]="30"></mat-spinner>
      }
      <ng-template #ordering>
        Zamawiam
        <mat-spinner [diameter]="30"></mat-spinner>
      </ng-template>
    </div>
  </div>
</ng-template>
<ng-template #tos>
  <p class="c0"><span class="c3">REGULAMIN SKLEPU INTERNETOWEGO</span></p>
  <p class="c0"><span class="c3">https://nowypanel.zalamo.com/ramki</span></p>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 1</span></p>
  <p class="c0"><span class="c3">POSTANOWIENIA OG&Oacute;LNE</span></p>
  <ol class="c4 lst-kix_4gaimjemyhwe-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Sklep https://nowypanel.zalamo.com/ramki dzia&#322;a na zasadach
        okre&#347;lonych w niniejszym Regulaminie.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Regulamin okre&#347;la warunki zawierania i rozwi&#261;zywania
        Um&oacute;w Sprzeda&#380;y Produktu oraz tryb post&#281;powania
        reklamacyjnego, a tak&#380;e rodzaje i zakres us&#322;ug
        &#347;wiadczonych drog&#261; elektroniczn&#261; przez Sklep
        https://nowypanel.zalamo.com/ramkil, zasady &#347;wiadczenia tych
        us&#322;ug, warunki zawierania i rozwi&#261;zywania um&oacute;w o
        &#347;wiadczenie us&#322;ug drog&#261; elektroniczn&#261;.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Ka&#380;dy Us&#322;ugobiorca z chwil&#261; podj&#281;cia czynno&#347;ci
        zmierzaj&#261;cych do korzystania z Us&#322;ug Elektronicznych Sklepu
        https://nowypanel.zalamo.com/ramki zobowi&#261;zany jest do
        przestrzegania postanowie&#324; niniejszego Regulaminu.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >W sprawach nieuregulowanych w niniejszym Regulaminie maj&#261;
        zastosowanie przepisy:</span
      >
    </li>
  </ol>
  <ol class="c4 lst-kix_4gaimjemyhwe-1 start" start="1">
    <li class="c7 li-bullet-0">
      <span class="c5"
        >ustawy o &#347;wiadczeniu us&#322;ug drog&#261; elektroniczn&#261; z
        dnia 18 lipca 2002 r.,</span
      >
    </li>
    <li class="c7 li-bullet-0">
      <span class="c5"
        >ustawy Kodeks cywilny z dnia 23 kwietnia 1964 r. oraz inne
        w&#322;a&#347;ciwe przepisy prawa polskiego.</span
      >
    </li>
  </ol>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 2</span></p>
  <p class="c0"><span class="c3">DEFINICJE ZAWARTE W REGULAMINIE</span></p>
  <ol class="c4 lst-kix_espv5jt420fl-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c6">FORMULARZ ZAM&Oacute;WIENIA</span
      ><span class="c5"
        >&nbsp;&ndash; formularz dost&#281;pny na stronie internetowej
        https://nowypanel.zalamo.com/ramki umo&#380;liwiaj&#261;cy
        z&#322;o&#380;enie Zam&oacute;wienia.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c6">KLIENT</span><span class="c9">, </span
      ><span class="c6">US&#321;UGOBIORCA </span
      ><span class="c5"
        >&ndash; osoba prawna lub osoba fizyczna prowadz&#261;ca
        dzia&#322;alno&#347;&#263; gospodarcz&#261;, kt&oacute;ry zamierza
        zawrze&#263; lub zawar&#322;a Umow&#281; Sprzeda&#380;y ze
        Sprzedawc&#261;.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c6">PRODUKT</span
      ><span class="c5"
        >&nbsp;&ndash; dost&#281;pna w Sklepie ramka na zdj&#281;cia
        b&#281;d&#261;ca przedmiotem Umowy Sprzeda&#380;y mi&#281;dzy Klientem a
        Sprzedawc&#261;.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c6">REGULAMIN</span
      ><span class="c5">&nbsp;- niniejszy regulamin Sklepu.</span>
    </li>
    <li class="c2 li-bullet-0">
      <span class="c6">SKLEP</span
      ><span class="c5"
        >&nbsp;- Sklep internetowy Us&#322;ugodawcy dzia&#322;aj&#261;cy pod
        adresem https://nowypanel.zalamo.com/ramki.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c6">SPRZEDAWCA</span><span class="c9">, </span
      ><span class="c6">US&#321;UGODAWCA</span
      ><span class="c5"
        >&nbsp;&ndash; <br />Zalamo R. Lucas, A. B&#322;aszczyk s.c. ul.
        Tadeusza Romanowicza 4 30-702 Krak&oacute;w, NIP 6793121479, REGON:
        363532030</span
      >
    </li>
  </ol>
  <ol class="c4 lst-kix_6p3h3z3jftzw-0 start" start="8">
    <li class="c2 li-bullet-0">
      <span class="c6">UMOWA SPRZEDA&#379;Y</span
      ><span class="c5"
        >&nbsp;&ndash; Umowa Sprzeda&#380;y Produktu zawarta mi&#281;dzy
        Klientem, a Sprzedawc&#261; za po&#347;rednictwem Formularza
        Zam&oacute;wienia https://nowypanel.zalamo.com/ramki.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c6">ZAM&Oacute;WIENIE</span
      ><span class="c5"
        >&nbsp;- o&#347;wiadczenie woli Klienta stanowi&#261;ce ofert&#281;
        zawarcia Umowy Sprzeda&#380;y Produktu ze Sprzedawc&#261;.</span
      >
    </li>
  </ol>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 3</span></p>
  <p class="c0">
    <span class="c3"
      >INFORMACJE DOTYCZ&#260;CE PRODUKT&Oacute;W ORAZ ICH ZAMAWIANIA</span
    >
  </p>
  <ol class="c4 lst-kix_3lxdyf95yjhh-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Sklep https://nowypanel.zalamo.com/ramki prowadzi sprzeda&#380;
        Produkt&oacute;w za po&#347;rednictwem sieci Internet.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Produkty oferowane w Sklepie s&#261; nowe, wolne od wad fizycznych i
        prawnych i zosta&#322;y legalnie wprowadzone na rynek polski.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Informacje znajduj&#261;ce si&#281; na stronach internetowych Sklepu
        nie stanowi&#261; oferty w rozumieniu przepis&oacute;w prawa. Klient,
        sk&#322;adaj&#261;c Zam&oacute;wienie, sk&#322;ada ofert&#281; kupna
        okre&#347;lonego Produktu na warunkach podanych w jego opisie.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Cena Produktu uwidoczniona na stronie internetowej Sklepu podana jest w
        z&#322;otych polskich (PLN) i zawiera wszystkie sk&#322;adniki. Cena nie
        zawiera koszt&oacute;w dostawy.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Zam&oacute;wienia mo&#380;na sk&#322;ada&#263; poprzez witryn&#281;
        internetow&#261; za pomoc&#261; Formularza Zam&oacute;wie&#324; (Sklep
        https://nowypanel.zalamo.com/ramki).</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Warunkiem z&#322;o&#380;enia Zam&oacute;wienia w Sklepie przez Klienta
        jest zapoznanie si&#281; z Regulaminem i akceptacja jego
        postanowie&#324; w czasie sk&#322;adania Zam&oacute;wienia.</span
      >
    </li>
  </ol>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 4</span></p>
  <p class="c0"><span class="c3">ZAWARCIE UMOWY SPRZEDA&#379;Y</span></p>
  <ol class="c4 lst-kix_6atfohobmw10-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Klientami sklepu mog&#261; zosta&#263; osoby fizyczne lub prawne
        prowadz&#261;ce dzia&#322;alno&#347;&#263; gospodarcz&#261; i
        posiadaj&#261;ce numer NIP.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Do zawarcia Umowy Sprzeda&#380;y, niezb&#281;dne jest wcze&#347;niejsze
        z&#322;o&#380;enie przez Klienta Zam&oacute;wienia udost&#281;pnionym
        przez Sprzedawc&#281; sposobem, zgodnie z &sect; 3 pkt 5 oraz 6
        Regulaminu.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Po z&#322;o&#380;eniu Zam&oacute;wienia Sprzedawca niezw&#322;ocznie
        potwierdza jego otrzymanie.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Potwierdzenie przyj&#281;cia Zam&oacute;wienia, o kt&oacute;rym mowa w
        pkt 2 niniejszego paragrafu powoduje zwi&#261;zanie Klienta jego
        Zam&oacute;wieniem. Potwierdzenie otrzymania Zam&oacute;wienia
        nast&#281;puje poprzez przes&#322;anie wiadomo&#347;ci e-mail.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Potwierdzenie otrzymania Zam&oacute;wienia zawiera potwierdzenie
        wszystkich istotnych element&oacute;w Zam&oacute;wienia.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Z chwil&#261; otrzymania przez Klienta wiadomo&#347;ci e-mail, o
        kt&oacute;rej mowa w pkt 4 niniejszego paragrafu, zostaje zawarta Umowa
        Sprzeda&#380;y mi&#281;dzy Klientem, a Sprzedawc&#261;.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c9"
        >Ka&#380;da Umowa Sprzeda&#380;y b&#281;dzie potwierdzana dowodem zakupu
        [faktur&#261;],</span
      ><span class="c9"
        >&nbsp;kt&oacute;ry b&#281;dzie przes&#322;ana drog&#261;
        elektroniczn&#261; w ci&#261;gu miesi&#261;ca od zawarcia Umowy
        Sprzeda&#380;y.</span
      ><span class="c5 c8"><br /></span>
    </li>
  </ol>
  <p class="c0"><span class="c3">&sect; 5</span></p>
  <p class="c0"><span class="c3">SPOSOBY P&#321;ATNO&#346;CI</span></p>
  <ol class="c4 lst-kix_3j1he7y1vt46-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Sprzedawca udost&#281;pnia nast&#281;puj&#261;cy spos&oacute;b
        p&#322;atno&#347;ci:</span
      >
    </li>
  </ol>
  <ol class="c4 lst-kix_3j1he7y1vt46-1 start" start="1">
    <li class="c7 li-bullet-0">
      <span class="c5"
        >p&#322;atno&#347;&#263; za po&#347;rednictwem elektronicznego systemu
        p&#322;atno&#347;ci.</span
      >
    </li>
  </ol>
  <ol class="c4 lst-kix_3j1he7y1vt46-0" start="2">
    <li class="c2 li-bullet-0">
      <span class="c9"
        >W przypadku p&#322;atno&#347;ci za po&#347;rednictwem elektronicznego
        systemu p&#322;atno&#347;ci Klient dokonuje zap&#322;aty przed
        rozpocz&#281;ciem realizacji Zam&oacute;wienia.</span
      >
    </li>
  </ol>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 6</span></p>
  <p class="c0">
    <span class="c3">KOSZT, TERMIN I SPOSOBY DOSTAWY PRODUKTU</span>
  </p>
  <ol class="c4 lst-kix_4pkftlio2pfb-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Koszty dostawy Produktu, kt&oacute;re pokrywa Klient, s&#261; ustalane
        w trakcie procesu sk&#322;adania Zam&oacute;wienia.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c9"
        >Produkt zostanie wykonany specjalnie na zam&oacute;wienie i
        wys&#322;any (dopiero po jego op&#322;aceniu) do ko&#324;ca
        pa&#378;dziernika 2022.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Zakupione w Sklepie Produkty s&#261; wysy&#322;ane wy&#322;&#261;cznie
        na terenie Polski za po&#347;rednictwem wyspecjalizowanej firmy.</span
      >
    </li>
  </ol>
  <p class="c1"><span class="c5"></span></p>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 7</span></p>
  <p class="c0"><span class="c3">REKLAMACJA PRODUKTU</span></p>
  <ol class="c4 lst-kix_pl0udn9o4pb2-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c6">Reklamacja z tytu&#322;u r&#281;kojmi.</span>
    </li>
  </ol>
  <ol class="c4 lst-kix_pl0udn9o4pb2-1 start" start="1">
    <li class="c7 li-bullet-0">
      <span class="c9"
        >Zawiadomienia o wadach dotycz&#261;cych Produktu oraz zg&#322;oszenie
        odpowiedniego &#380;&#261;dania mo&#380;na dokona&#263; za
        po&#347;rednictwem poczty elektronicznej na adres:
        michal&#64;zalamo.com</span
      ><span class="c5">.</span>
    </li>
    <li class="c7 li-bullet-0">
      <span class="c9">W</span
      ><span class="c9"
        >&nbsp;powy&#380;szej wiadomo&#347;ci w formie elektronicznej
        nale&#380;y poda&#263; jak najwi&#281;cej informacji i okoliczno&#347;ci
        dotycz&#261;cych przedmiotu reklamacji, w szczeg&oacute;lno&#347;ci
        rodzaj i dat&#281; wyst&#261;pienia nieprawid&#322;owo&#347;ci oraz dane
        kontaktowe. Podane informacje znacznie u&#322;atwi&#261; i
        przyspiesz&#261; rozpatrzenie reklamacji przez Sprzedawc&#281;.</span
      >
    </li>
    <li class="c7 li-bullet-0">
      <span class="c5"
        >Sprzedawca ustosunkuje si&#281; do &#380;&#261;dania Klienta
        niezw&#322;ocznie, nie p&oacute;&#378;niej ni&#380; w terminie 14 dni od
        momentu zg&#322;oszenia reklamacji.</span
      >
    </li>
  </ol>
  <p class="c1 c15"><span class="c5"></span></p>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 9</span></p>
  <p class="c0">
    <span class="c3">RODZAJ I ZAKRES US&#321;UG ELEKTRONICZNYCH</span>
  </p>
  <ol class="c4 lst-kix_jhpwn43zlgny-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Us&#322;ugodawca umo&#380;liwia za po&#347;rednictwem Sklepu
        korzystanie z Us&#322;ugi Elektronicznej jak&#261; jest zawieranie
        Um&oacute;w Sprzeda&#380;y Produktu.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >&#346;wiadczenie Us&#322;ugi Elektronicznej na rzecz
        Us&#322;ugobiorc&oacute;w w Sklepie odbywa si&#281; na warunkach
        okre&#347;lonych w Regulaminie.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Us&#322;ugodawca ma prawo do zamieszczania na stronie internetowej
        Sklepu tre&#347;ci reklamowych. Tre&#347;ci te, stanowi&#261;
        integraln&#261; cz&#281;&#347;&#263; Sklepu i prezentowanych w nim
        materia&#322;&oacute;w.</span
      >
    </li>
  </ol>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 10</span></p>
  <p class="c0">
    <span class="c3"
      >WARUNKI &#346;WIADCZENIA I ZAWIERANIA UM&Oacute;W O &#346;WIADCZENIE
      US&#321;UG ELEKTRONICZNYCH</span
    >
  </p>
  <ol class="c4 lst-kix_688r54188zmm-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >&#346;wiadczenie Us&#322;ugi Elektronicznej okre&#347;lonej w &sect; 9
        pkt 1 Regulaminu przez Us&#322;ugodawc&#281; jest
        nieodp&#322;atne.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Umowa o &#347;wiadczenie Us&#322;ugi Elektronicznej polegaj&#261;cej na
        umo&#380;liwieniu z&#322;o&#380;enia Zam&oacute;wienia w Sklepie
        zawierana jest na czas oznaczony i ulega rozwi&#261;zaniu z chwil&#261;
        z&#322;o&#380;enia Zam&oacute;wienia albo zaprzestania jego
        sk&#322;adania przez Us&#322;ugobiorc&#281;.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Wymagania techniczne niezb&#281;dne do wsp&oacute;&#322;pracy z
        systemem teleinformatycznym, kt&oacute;rym pos&#322;uguje si&#281;
        Us&#322;ugodawca:</span
      >
    </li>
  </ol>
  <ol class="c4 lst-kix_688r54188zmm-1 start" start="1">
    <li class="c7 li-bullet-0">
      <span class="c5"
        >komputer (lub urz&#261;dzenie mobilne) z dost&#281;pem do
        Internetu,</span
      >
    </li>
    <li class="c7 li-bullet-0">
      <span class="c5">dost&#281;p do poczty elektronicznej,</span>
    </li>
    <li class="c7 li-bullet-0">
      <span class="c5">przegl&#261;darka internetowa,</span>
    </li>
    <li class="c7 li-bullet-0">
      <span class="c5"
        >w&#322;&#261;czenie w przegl&#261;darce internetowej Cookies oraz
        Javascript.</span
      >
    </li>
  </ol>
  <ol class="c4 lst-kix_688r54188zmm-0" start="4">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Us&#322;ugobiorca zobowi&#261;zany jest do korzystania ze Sklepu w
        spos&oacute;b zgodny z prawem i dobrymi obyczajami maj&#261;c na uwadze
        poszanowanie d&oacute;br osobistych i praw w&#322;asno&#347;ci
        intelektualnej os&oacute;b trzecich.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Us&#322;ugobiorca zobowi&#261;zany jest do wprowadzania danych zgodnych
        ze stanem faktycznym.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Us&#322;ugobiorc&#281; obowi&#261;zuje zakaz dostarczania tre&#347;ci o
        charakterze bezprawnym.</span
      >
    </li>
  </ol>
  <p class="c1"><span class="c5"></span></p>
  <p class="c0"><span class="c3">&sect; 11</span></p>
  <p class="c0">
    <span class="c3"
      >REKLAMACJE ZWI&#260;ZANE ZE &#346;WIADCZENIEM US&#321;UG
      ELEKTRONICZNYCH</span
    >
  </p>
  <ol class="c4 lst-kix_lbzn1lo4odwa-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Reklamacje zwi&#261;zane ze &#347;wiadczeniem Us&#322;ugi
        Elektronicznej za po&#347;rednictwem Sklepu Us&#322;ugobiorca mo&#380;e
        sk&#322;ada&#263; za po&#347;rednictwem poczty elektronicznej na adres:
        michal&#64;zalamo.com.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >W powy&#380;szej wiadomo&#347;ci e-mail, nale&#380;y poda&#263; jak
        najwi&#281;cej informacji i okoliczno&#347;ci dotycz&#261;cych
        przedmiotu reklamacji, w szczeg&oacute;lno&#347;ci rodzaj i dat&#281;
        wyst&#261;pienia nieprawid&#322;owo&#347;ci oraz dane kontaktowe. Podane
        informacje znacznie u&#322;atwi&#261; i przyspiesz&#261; rozpatrzenie
        reklamacji przez Us&#322;ugodawc&#281;.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Rozpatrzenie reklamacji przez Us&#322;ugodawc&#281; nast&#281;puje
        niezw&#322;ocznie, nie p&oacute;&#378;niej ni&#380; w terminie 14 dni od
        momentu zg&#322;oszenia.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Odpowied&#378; Us&#322;ugodawcy w sprawie reklamacji jest wysy&#322;ana
        na adres e-mail Us&#322;ugobiorcy podany w zg&#322;oszeniu reklamacyjnym
        lub w inny podany przez Us&#322;ugobiorc&#281; spos&oacute;b<br
      /></span>
    </li>
  </ol>
  <p class="c0"><span class="c3">&sect; 12</span></p>
  <p class="c0"><span class="c3">POSTANOWIENIA KO&#323;COWE</span></p>
  <ol class="c4 lst-kix_376qyfjk0vgw-0 start" start="1">
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Umowy zawierane poprzez Sklep zawierane s&#261; zgodnie z prawem
        polskim.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >W przypadku niezgodno&#347;ci jakiejkolwiek cz&#281;&#347;ci Regulaminu
        z obowi&#261;zuj&#261;cym prawem, w miejsce zakwestionowanego przepisu
        Regulaminu zastosowanie maj&#261; w&#322;a&#347;ciwe przepisy prawa
        polskiego.</span
      >
    </li>
    <li class="c2 li-bullet-0">
      <span class="c5"
        >Wszelkie spory wynik&#322;e z Um&oacute;w Sprzeda&#380;y mi&#281;dzy
        Sklepem a Klientami b&#281;d&#261; rozstrzygane w pierwszej
        kolejno&#347;ci na drodze negocjacji, z intencj&#261; polubownego
        zako&#324;czenia sporu, z uwzgl&#281;dnieniem ustawy o pozas&#261;dowym
        rozwi&#261;zywaniu spor&oacute;w konsumenckich. Je&#347;li jednak nie
        by&#322;oby to mo&#380;liwe, lub te&#380; by&#322;oby
        niesatysfakcjonuj&#261;ce dla kt&oacute;rejkolwiek ze stron, spory
        b&#281;d&#261; rozstrzygane przez w&#322;a&#347;ciwy s&#261;d
        powszechny, zgodnie z pkt 4 niniejszego paragrafu.</span
      >
    </li>
  </ol>
  <p class="c10"><span class="c11"></span></p>
  <p class="c10"><span class="c11"></span></p>
</ng-template>
